import { render } from "./session-details.vue?vue&type=template&id=4d1a8e46&lang=pug"
import script from "./session-details.vue?vue&type=script&setup=true&lang=js"
export * from "./session-details.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__